import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './ReasonsView.css';
import { Loader } from 'semantic-ui-react';
import ReasonsDropdownList from './ReasonsDropdownList';
import NoReasonsFound from '../NoReasonsFound';

export default class ReasonsView extends React.Component {

  get content() {
    const { appointmentTypes, hasFetched, value, onReasonSelected, connectionName } = this.props;
    if ( appointmentTypes && appointmentTypes.length > 0 ) {
      return (
        <ReasonsDropdownList 
          appointmentTypes={appointmentTypes} 
          value={value} 
          onReasonSelected={onReasonSelected} 
        />
      );
    }
    if ( !hasFetched ) return <div><Loader active inline='centered'>Loading reasons...</Loader></div>;
    return <NoReasonsFound name={connectionName} />;
  }

  render() {
    return (
      <div className={css['content']}>
        <div>What do you need help with?</div>
        {this.content}
      </div>
    );
  }
}

ReasonsView.propTypes = {
  appointmentTypes: PropTypes.array,
  hasFetched: PropTypes.bool.isRequired,
  value: SFEntityID,
  onReasonSelected: PropTypes.func.isRequired,
  connectionName: PropTypes.string.isRequired
};
